import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ba20528"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand_list" }
const _hoisted_2 = { style: {"background":"#fff","padding":"0 30px 20px","border-radius":"4px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_4 = { style: {"margin-bottom":"20px","display":"flex","justify-content":"space-between","align-items":"center","height":"50px","box-shadow":"inset 0px -1px 0px 0px rgba(232, 232, 232, 1)"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "moduleTitle" }, "品牌列表", -1))
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = {
  key: 0,
  class: "spaceAroundBtn"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "刷新", -1))
const _hoisted_9 = { class: "batch" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "密度", -1))
const _hoisted_11 = { class: "SettingOutlinedBox" }
const _hoisted_12 = { class: "tableBox" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "buttonBox" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新建", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stick" }, "|", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "编辑", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stick" }, "|", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1))
const _hoisted_20 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_FileAddFilled = _resolveComponent("FileAddFilled")!
  const _component_ReloadOutlined = _resolveComponent("ReloadOutlined")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_ColumnHeightOutlined = _resolveComponent("ColumnHeightOutlined")!
  const _component_Image = _resolveComponent("Image")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Modaladd = _resolveComponent("Modaladd")!
  const _component_EditModal = _resolveComponent("EditModal")!
  const _component_ChildModal = _resolveComponent("ChildModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Input, {
      value: _ctx.searchBrand,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchBrand) = $event)),
      placeholder: "请输入...",
      onKeyup: _withKeys(_ctx.search, ["enter"]),
      style: {"width":"432px","height":"40px","margin-bottom":"20px"},
      allowClear: ""
    }, null, 8, ["value", "onKeyup"]),
    _createVNode(_component_Button, {
      type: "primary",
      onClick: _ctx.search,
      style: {"margin":"0 12px","width":"72px","height":"40px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SearchOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
        _createTextVNode(" 搜索 ")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_Button, {
      onClick: _ctx.reset,
      style: {"width":"72px","height":"40px","border-color":"#008bcf","color":"#008bcf"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SyncOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
        _createTextVNode(" 重置 ")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            type: "primary",
            style: {"margin":"0 0 0 16px"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal())),
            class: "spaceAroundBtn"
          }, {
            default: _withCtx(() => [
              (_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_brand_add)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_FileAddFilled),
                    _createTextVNode(" 新建品牌")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Popover, null, {
            content: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "SettingOutlinedBox",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getBrandList && _ctx.getBrandList(...args)))
              }, [
                _createVNode(_component_ReloadOutlined)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Popover, {
            trigger: "click",
            placement: "bottom"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(this.batchStyle == 'default' ? 'active' : ''),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.batchStyle = 'default'))
                }, " 宽松 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(this.batchStyle == 'middle' ? 'active' : ''),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchStyle = 'middle'))
                }, " 默认 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(this.batchStyle == 'small' ? 'active' : ''),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.batchStyle = 'small'))
                }, " 紧凑 ", 2)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Popover, null, {
                content: _withCtx(() => [
                  _hoisted_10
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ColumnHeightOutlined)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.showTable)
          ? (_openBlock(), _createBlock(_component_Table, {
              key: 0,
              rowKey: "brandCode",
              columns: _ctx.columns,
              "data-source": _ctx.data,
              pagination: false,
              scroll: _ctx.scroll,
              loading: _ctx.loading,
              indentSize: 25,
              size: _ctx.batchStyle,
              defaultExpandAllRows: _ctx.defaultExpandAllRows
            }, {
              brandName: _withCtx(({ record }) => [
                _createElementVNode("span", {
                  title: record.brandName
                }, _toDisplayString(record.brandName), 9, _hoisted_13)
              ]),
              logo: _withCtx(({ record }) => [
                _createVNode(_component_Image, {
                  width: 50,
                  style: {"max-height":"40px","object-fit":"cover"},
                  src: record.imgLogo
                }, null, 8, ["src"])
              ]),
              handle: _withCtx(({ record }) => [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Button, {
                    type: "text",
                    class: _normalizeClass(["firstButton", record.level >= 4 || !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_brand_add? 'disableText' : '']),
                    onClick: ($event: any) => (_ctx.showChildModal(record)),
                    disabled: record.level >= 4 || !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_brand_add
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PlusOutlined, { class: "icon" }),
                      _hoisted_15
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick", "disabled"]),
                  _hoisted_16,
                  _createVNode(_component_Button, {
                    type: "text",
                    class: _normalizeClass(["secondButton", !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_brand_edit? 'disableText' : '']),
                    disabled: !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_brand_edit,
                    onClick: ($event: any) => (_ctx.showEditModal(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditOutlined, { class: "icon" }),
                      _hoisted_17
                    ]),
                    _: 2
                  }, 1032, ["class", "disabled", "onClick"]),
                  _hoisted_18,
                  _createVNode(_component_Button, {
                    type: "text",
                    class: _normalizeClass(["lastButton", !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_brand_del? 'disableText' : '']),
                    disabled: !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_brand_del,
                    onClick: ($event: any) => (_ctx.handleDeleteBrand(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DeleteOutlined, { class: "icon" }),
                      _hoisted_19
                    ]),
                    _: 2
                  }, 1032, ["class", "disabled", "onClick"])
                ])
              ]),
              _: 1
            }, 8, ["columns", "data-source", "scroll", "loading", "size", "defaultExpandAllRows"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode(_component_Pagination, {
          "show-size-changer": "",
          "show-quick-jumper": "",
          current: _ctx.pageCurrent,
          "onUpdate:current": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageCurrent) = $event)),
          pageSize: _ctx.pageSize,
          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageSize) = $event)),
          total: _ctx.total,
          onShowSizeChange: _ctx.onShowSizeChange,
          "page-size-options": ['10', '20', '50', '100']
        }, null, 8, ["current", "pageSize", "total", "onShowSizeChange"])
      ])
    ]),
    _createVNode(_component_Modaladd, {
      ref: "showModal",
      onTodoTeload: _ctx.todoTeload
    }, null, 8, ["onTodoTeload"]),
    _createVNode(_component_EditModal, {
      ref: "showEditModal",
      onTodoTeload: _ctx.todoTeload,
      brandList: _ctx.data
    }, null, 8, ["onTodoTeload", "brandList"]),
    _createVNode(_component_ChildModal, {
      ref: "showChildModal",
      onTodoTeload: _ctx.todoTeload,
      brandList: _ctx.data
    }, null, 8, ["onTodoTeload", "brandList"])
  ]))
}